var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag||'div',_vm._g(_vm._b({tag:"component",staticClass:"responsive"},'component',_vm.$attrs,false),_vm.$listeners),[_c('div',{style:(_vm.style)}),_c('div',{staticClass:"responsive-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }